import { render } from "./Spinner.vue?vue&type=template&id=0bd9dc30&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=0bd9dc30&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0bd9dc30"

export default script